/**
 * Meta Pixel tracking helpers. Safely no-op if fbq isn't loaded
 * (ad-blockers, no-script, etc.).
 */
export function track(event, params = {}) {
  try {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", event, params);
    }
  } catch (_) { /* swallow */ }
}

export function trackLead(params = {}) { track("Lead", params); }
export function trackInitiateCheckout(params = {}) { track("InitiateCheckout", params); }
export function trackPurchase(value, currency = "INR", extra = {}) { track("Purchase", { value, currency, ...extra }); }
export function trackCompleteRegistration() { track("CompleteRegistration"); }
